import React, { useEffect } from "react";
import { Table } from "antd";
import Page from "../../common/components/Page";
import useActiveWarrants from "./useActiveWarrants";
import { useLocation } from "react-router";
import CleanButton from "../../common/components/CleanButton";
import PDFModal from "../../common/components/PDFModal";
import BannerCard from "../../common/components/BannerCard";

interface StateType {
  state: {
    returnData?: any;
  };
  key: string;
  pathname: string;
  search: string;
  hash: string;
}

const ActiveWarrants = () => {
  const { data, setCondition, setSearch, handleSearch, columns, loading, setData, fixedColumns, fixedData, visibility, setVisibility, handleViewPDF } = useActiveWarrants();
  const location = useLocation();

  useEffect(() => {
    const stateObject: StateType = { ...location };
    if (stateObject.state && stateObject.state.returnData) {
      setData(stateObject.state.returnData);
    } else {
      setData(null);
    }
  }, [location, setData]);

  return (
    <Page>
      <Page.Title title="Traffic/Criminal Case Lookup" icon="search" />
      <Page.Controls onConditionChange={setCondition} onSearchChange={(e) => setSearch(e.target.value)} onSearch={handleSearch} fromPage={true} loading={loading}></Page.Controls>
      <Page.Content>
        {data && data.length ? (
          <>
            <CleanButton onClick={handleViewPDF} icon="eye">
              View PDF
            </CleanButton>
            <PDFModal visibility={visibility} setVisibility={setVisibility} data={data} fromScreen="AW" />
            <Table loading={loading} size="small" columns={columns} dataSource={data} scroll={{ x: 720 }} />
          </>
        ) : (
          <BannerCard title="Description of lookup option(s)">
            <Table size="small" columns={fixedColumns} dataSource={fixedData} pagination={false} />
          </BannerCard>
        )}
      </Page.Content>
    </Page>
  );
};

export default ActiveWarrants;
